import React, { useEffect, useState } from 'react';
import CourseCard from '../course-card/CourseCard';
import './sectionseven.css';
import illustration from '../../assets/courses-illustration.svg';
import path from '../../assets/path.svg';
import scratch from '../../assets/scratch.png';
import scratchIntermediate from '../../assets/scratch-intermediate.png';
import scratchAdvance from '../../assets/scratch-advance.png';
import pythonIntro from '../../assets/python-intro.png';
import pythonAdvance from '../../assets/python-advance.png';
import animation from '../../assets/animation.png';
import icon from '../../assets/shape.svg';
import axios from 'axios';


function SectionSeven() {

    const [country, setCountry] = useState([]);


    useEffect(() =>
    {
    axios.get(`https://api.iploka.com/check?api_key=${process.env.REACT_APP_KEY}`)
    .then(res=>{
        setCountry(res.data);
        setCountry(res.data['country_name']);
        
    })
    .catch((err) => {
        console.log(err);
    });
    

    }, []
    )






    return (
        <div className='sectionSeven__main'>
            <img src={illustration} alt="" className="course__illustration" />
            <div className="sectionSeven__top">
                <h2 className="head__three">Quality Learning 
Through Our Lessons</h2>
<img src={path} alt=""  className="path"/>
            </div>
            <div className="sectionSeven__course">

            <CourseCard 
            courseImg={scratch}
            icon={icon}
            age=' 6 - 16' 
            currency={country === 'Nigeria' ? '₦' : '$'}
            price={country === 'Nigeria' ? '25,000' : '150'}
            prequisite='none' 
            title='Beginner Scratch Class' 
            duration=' 10weeks (2 hours every saturday)' 
            location='Online (Zoom)' 
            description='This course is for aspiring programmers with 
            little or no programming experience. Students
            will be introduced to the fundamentals of 
            programming'
            fullDesc='This course is for aspiring programmers with little or no programming experience. Students will be introduced to the fundamentals of programming. They will learn basic Computer Science concepts through project based learning using Scratch version 3.0.  Students will learn to create games, animations and stories. This course is designed to enable children acquire computational thinking skills. Concepts to be taught include algorithm, concurrency, sequencing, looping, conditional statements, events handling and variables.'
            
            />
            <CourseCard 
            courseImg={scratchIntermediate}
            icon={icon}
            age=' 6 - 16' 
            currency={country === 'Nigeria' ? '₦' : '$'}
            price={country === 'Nigeria' ? '25,000' : '70'}
            prequisite='Basic Knowledge of Scratch' 
            title='Intermediate Scratch Class 1' 
            duration=' 10weeks (2 hours every saturday)' 
            location='Online (Zoom)' 
            description='This course is design for kids with basic 
            programmers experience in scratch. Students 
            will be introduced to the fundamentals of  
            programming'
            fullDesc='This course is designed for children with basic programming experience in scratch. Students will be introduced to the fundamentals of programming. They will learn additional Computer Science concepts through project based learning on Scratch version 3.0.  Students will create games, animations and stories using more features available on scratch. This course is designed to enable children further enhance their computational thinking skills. Concepts to be taught include mathematical, relational and logical operators and object oriented programming. The older children will recreate various arcade games. Children will be work both independently and in collaboration with other students and in the process, improve their creativity, problem solving and logical reasoning skills.'
            
            />
            <CourseCard 
            courseImg={scratchAdvance}
            icon={icon}
            age='12 - 16' 
            currency={country === 'Nigeria' ? '₦' : '$'}
            price={country === 'Nigeria' ? '30,000' : '100'}
            prequisite='Basic Knowledge of Scratch' 
            title='Intermediate Scratch class 2' 
            duration=' 10weeks (2 hours every saturday)' 
            location='Online (Zoom)' 
            description='Students will create games, animations and stories using more features available on scratch. This course is designed to enable children further enhance their computational thinking skills.'
            fullDesc='This course is designed for children with good programming experience in scratch who wish to gain advanced knowledge in the use of Computer Science concepts to develop more complex projects using scratch. Students will create multi-level games. Concepts to be taught include procedures, recursion and list.'
            
            />
            <CourseCard 
            courseImg={pythonIntro}
            icon={icon}
            age='6 -16' 
            currency={country === 'Nigeria' ? '₦' : '$'}
            price={country === 'Nigeria' ? '30,000' : '150'}
            prequisite='none' 
            title='Introduction to Python' 
            duration=' 10weeks (2 hours every saturday)' 
            location='Online (Zoom)' 
            description='This course is for aspiring programmers with 
            little or no programming experience. Students
            will be introduced to the fundamentals of 
            programming'
            fullDesc='This course introduces children to python programming Language. Python is the most widely used language in the 21st Century Python is great for Web development, Data Analysis, Artificial Intelligence (AI), Internet of Things (IOT), robotics and embedded electronics applications. It has a very friendly syntax and is easy for children to learn.  Students will learn the basis of python. Topics to be covered in this course include Introduction to Python syntax, data types, input/output statements, conditional statements, variables, functions, loops and iterations and file operations. Children will learn Python in a fun and interactive manner and will create games using the concepts learnt in class.'
            
            />
            {/* <CourseCard 
            courseImg={pythonAdvance}
            icon={icon}
            age='6 -16' 
            currency={country === 'Nigeria' ? '₦' : '$'}
            price={country === 'Nigeria' ? '30,000' : '150'}
            prequisite='Basic knowledge of python'  
            title='Introduction to Python II' 
            duration=' 10weeks (2 hours every saturday)' 
            location='Online (Zoom)' 
            description='In this course, they will be introduced to concepts in Object-Oriented Programming, functions and methods, Practical graphical programming using turtle and game programming in Python.'
            
            /> */}
            <CourseCard 
            courseImg={animation}
            icon={icon}
            age='6 -16' 
            currency={country === 'Nigeria' ? '₦' : '$'}
            price={country === 'Nigeria' ? '30,000' : '150'}
            prequisite='none'  
            title='Introduction to Animation' 
            duration=' 10weeks (2 hours every saturday)' 
            location='Online (Zoom)' 
            description='This course is an introductory course for animation. Little or no knowledge of 3D is required. Students will be introduced to the fundamentals of 3D and animation'
            fullDesc='3D animation is the process of generating three-dimensional moving images in a digital environment. Careful manipulation of 3D models or objects is carried out within 3D software for exporting picture sequences giving them the illusion of animation or movement. Today, 3D animation is used extensively in different fields for a variety of purposes. The topics to be covered in this course include 3D Modeling (Hard surface and character), texturing, lighting, rigging, animation and post-production.'
            />
           
            </div>
        </div>
    )
}

export default SectionSeven
